import React from 'react';
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { RouteNameEnum } from '../enums/routeName';
import AuthRoutes from '../features/auth/routes';
import BoUserRoutes from '../features/boUser/routes';
import CustomerRoutes from '../features/customer/routes';
import DashboardRoutes from '../features/dashboard/routes';
import FeaturedBannerRoutes from '../features/featuredBanner/routes';
import FeaturedContentRoutes from '../features/featuredContent/routes';
import NewsRoutes from '../features/news/routes';
import NotificationRoutes from '../features/notification/routes';
import EventRoutes from '../features/event/routes';
import useAuth from '../hooks/useAuth';

const NavigateRoot: React.FC = () => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated
    ? <Navigate to={RouteNameEnum.dashboard.index} />
    : <Navigate to={RouteNameEnum.auth.login} />;
};

const BaseRouter: React.FC = () => (
  <BrowserRouter>
    <AuthRoutes />
    <DashboardRoutes />
    <BoUserRoutes />
    <CustomerRoutes />
    <EventRoutes />
    <FeaturedBannerRoutes />
    <FeaturedContentRoutes />
    <NewsRoutes />
    <NotificationRoutes />
    <Routes>
      <Route path="/" element={<NavigateRoot />} />
    </Routes>
    <ToastContainer />
  </BrowserRouter>
);

export default BaseRouter;
